import {
  ItemPageAlertDto,
  ItemPageAlertsPluginModel,
} from '@marketplace-web/item-page/item-page-data'

import { transformItemAlertDto } from '@marketplace-web/item-box/product-item-data'

export const getItemPageItemAlertsPluginModel = (
  data: ItemPageAlertDto,
): ItemPageAlertsPluginModel => ({
  itemId: data.item_id,
  itemAlert: transformItemAlertDto(data.item_alert),
})
